module.exports = __webpack_public_path__ + "static/InputField_secure-b151bb5715fc9fffeed52058e66470ff.png";